import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import React, { Suspense } from 'react';
import SectionSocialMediaChart from './social-media/section-social-media-chart';
import SectionCancelPaymentChart from './social-media/section-user-cancel-payment';
import SectionUserPaidReturnChart from './social-media/section-user-paid-return-chart';
import SectionUserTransferRatingChart from './social-media/section-user-transfer-rating-chart';
import SkeletonBarChart from '../sekeletons/skeleton-bar-chart';
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
export default function SectionTrackingUser() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-6 rounded-lg py-4"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonBarChart, null)
    }, /*#__PURE__*/ React.createElement(SectionSocialMediaChart, null)), /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonBarChart, null)
    }, /*#__PURE__*/ React.createElement(SectionUserTransferRatingChart, null)), /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonBarChart, null)
    }, /*#__PURE__*/ React.createElement(SectionUserPaidReturnChart, null)), /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonBarChart, null)
    }, /*#__PURE__*/ React.createElement(SectionCancelPaymentChart, null)));
}
